import React from "react";

const Row = ({ children }) => (
  <div style={{ display: "flex", alignItems: "center" }}>{children || ""}</div>
);

export default Row;
